module.exports = __webpack_public_path__ + "img/14_50.196858c9.png";